import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const courseApi = createApi({
  reducerPath: "courseApi",

  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Course/`),
  endpoints: (builder) => ({
    getAllCourse: builder.query({
      query: () => ({
        url: "GetCourses",
        method: "GET",
      }),
    }),

    addCourse: builder.mutation({
      query: (body) => {
        return {
          url: "AddCourse",
          method: "POST",
          body,
        };
      },
    }),

    updateCourse: builder.mutation({
      query: ( body ) => {
        return {
          url: "UpdateCourse",
          method: "PUT",
          body,
        };
      },
    }),
    deleteCourse: builder.mutation({
      query: id => ({
        url: `DeleteCourse?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddCourseMutation,
  useGetAllCourseQuery,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
} = courseApi;

export default courseApi.reducer;
